import { render } from "./Cart.vue?vue&type=template&id=350bac95&ts=true"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__